import gql from 'graphql-tag';

export default gql`
  subscription updatedUser($id: ID!) {
    updatedUser(id: $id) {
      id
    }
  }
`;
